import { useState } from "react";
import { BsClipboard, BsCheck2Square} from "react-icons/bs";
import Footer from "./Footer";

const About = ({ image }) => {

  const [isEmailCopied, setIsEmailCopied] = useState(false);
  const [isLinkedCopied, setIsLinkedCopied] = useState(false);

  return (
    <div className="mt-28 flex items-center justify-center">
      <div className="container w-200">
        
        <div className="">
          <p className="leading-7">
            Introducing the one and only, the man who can build a website faster than you can say "HTML," the IT whiz from Kerala, the React.js extraordinaire, the Skillshare sensation, the YouTube guru, Peter Johnson! With a passion for web technologies and a knack for sharing his knowledge, Peter is like a walking encyclopedia of all things tech. He's built more projects than a Lego master builder and has more watch time than a Netflix binge-watcher. So buckle up and get ready for a wild ride into the world of web development, because with Peter by your side, anything is possible (except maybe getting a date, but we won't hold that against him).
          </p>
        </div>

        <div className="flex items-center pt-5">
          <p className="font-extralight mr-5">Drop me a mail @ <span className="underline font-light">peterj1298@gmail.com</span></p>
          <div
            className="cursor-pointer"
              onClick = { () => {
                navigator.clipboard.writeText("peterj1298@gmail.com");
                setIsEmailCopied(true);
                setTimeout(() => {
                  setIsEmailCopied(false);
                }, 5000);
              }}
            >
              {isEmailCopied === true ? (<BsCheck2Square />) : (<BsClipboard />)}
            </div>
        </div>

        <div className="flex items-center pt-2">
          <p className="font-extralight mr-5">Connect with me on <span className="underline"><a href="https://www.linkedin.com/in/peterjohns0n/">LinkedIn</a></span> / <span className="underline font-light">https://www.linkedin.com/in/peterjohns0n/</span></p>
          <div
            className="cursor-pointer"
              onClick = { () => {
                navigator.clipboard.writeText("https://www.linkedin.com/in/peterjohns0n/");
                setIsLinkedCopied(true);
                setTimeout(() => {
                  setIsLinkedCopied(false);
                }, 5000);
              }}
            >
              {isLinkedCopied === true ? (<BsCheck2Square />) : (<BsClipboard />)}
            </div>
        </div>
      </div>
      {/* <Footer/> */}
      <div className="w-80">
        <img className="h-52 rounded-full" src="./image/myPhoto.JPG" />
      </div>
    </div>
  );
};

export default About;
